export default {
  ORDER_KH: 0,
  ORDER_DV: 1,
  ORDER_VP: 2,
  ORDER_DT: 3,
  ORDER_LIXI: 5
}



// WEBPACK FOOTER //
// ./src/communicate/OrderType.js